import styled from "styled-components/macro";
import type { ElearningTheme } from "themes/elearning.theme";
import type { DashProgressBarProps } from "./DashProgressBar.model";

interface Props {
  theme: ElearningTheme;
}

type StyledProgressBarProps = DashProgressBarProps & Props;

export const StyledProgressBar = styled.div<Props>`
  max-width: 200px;
  display: flex;
  justify-content: space-between;
`;

export const StyledProgressItem = styled.div<StyledProgressBarProps>`
  margin-right: 0.7rem;
  width: 2.5rem;
  height: 0.5rem;
  border-radius: 6px;
  background-color: #B4C2E2;

  ${({ progress, theme }: StyledProgressBarProps) =>
    Array.from(
      { length: Math.ceil(progress / 20) },
      (_, index) => `
      &:nth-child(${index + 1}) {
        background-color: ${theme.palette.secondary._900};
      }
    `,
    ).join("")}
`;
